<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import NavMain from './components/header/NavMain.vue';
import FooterMain from './components/footer/FooterMain.vue';
import NotifyModal from './components/modal/NotifyModal.vue';

const route = useRoute();

const store = useStore();
// window.store = store; // uncomment for debugging store
store.dispatch('initialize');

const eventTypes = computed(() => store.getters.links);

const showNotifyModal = ref(false);

</script>
<template>
  <notify-modal v-if="showNotifyModal"
    class="z-1"
    @close="showNotifyModal = false"
    @registered="showNotifyModal = false"
  />

  <header class="bg-white shadow-[0_5px_8px_#00000029] tablet:mb-6">
    <nav-main
      class="z-0"
      :eventTypes="eventTypes" @notify="showNotifyModal = true"
    />
  </header>
  <main id="main" class="flex-1 container-xxl bg-white text-ford-blue-dark">
    <router-view :key="route.fullPath" />
  </main>
  <footer-main :eventTypes="eventTypes" @notify="showNotifyModal = true" />
</template>
